import React, { useState } from 'react'
import Lightbox from '../components/Lightbox'
import galleryData from '../data/galleryData'

export default function Events() {
  const [lbIndex, setLbIndex] = useState(null)
  const open = i => setLbIndex(i)
  const close = () => setLbIndex(null)
  const prev = () => setLbIndex(i => (i - 1 + galleryData.length) % galleryData.length)
  const next = () => setLbIndex(i => (i + 1) % galleryData.length)

  return (
    <div>
      <div className="page-header">
        <div className="max-w-7xl mx-auto px-2">
          <h1>Gallery</h1>
          <p className="breadcrumb">Home › Gallery</p>
        </div>
      </div>

      <section className="py-16" style={{background:'var(--cream)'}}>
        <div className="max-w-7xl mx-auto px-6">
          <div className="text-center mb-12">
            <div className="section-tag" style={{justifyContent:'center'}}>Our Moments</div>
            <h2 style={{fontFamily:'Playfair Display,serif',fontSize:'clamp(26px,4vw,40px)',fontWeight:700,color:'var(--navy)'}}>Photo Gallery</h2>
          </div>
          <div className="grid grid-cols-1 sm:grid-cols-2 md:grid-cols-3 lg:grid-cols-4 gap-5">
            {galleryData.map((item, i) => (
              <div key={item.id} onClick={() => open(i)}
                className="rounded-2xl overflow-hidden cursor-pointer group relative"
                style={{boxShadow:'0 4px 16px rgba(13,27,62,0.08)'}}>
                <img src={item.src} alt={item.caption} className="w-full object-cover transition-transform duration-500 group-hover:scale-105" style={{height:'220px'}}/>
                <div className="absolute inset-0 flex items-center justify-center opacity-0 group-hover:opacity-100 transition-all duration-300 rounded-2xl"
                  style={{background:'rgba(13,27,62,0.55)'}}>
                  <div className="w-12 h-12 rounded-full bg-white/20 border border-white/40 flex items-center justify-center">
                    <svg className="w-5 h-5 text-white" fill="none" stroke="white" strokeWidth="2" viewBox="0 0 24 24"><circle cx="11" cy="11" r="8"/><line x1="21" y1="21" x2="16.65" y2="16.65"/><line x1="11" y1="8" x2="11" y2="14"/><line x1="8" y1="11" x2="14" y2="11"/></svg>
                  </div>
                </div>
                <div className="absolute bottom-0 left-0 right-0 p-3 text-white text-sm font-medium opacity-0 group-hover:opacity-100 transition-all duration-300"
                  style={{background:'linear-gradient(transparent,rgba(13,27,62,0.8))'}}>
                  {item.caption}
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {lbIndex !== null && <Lightbox images={galleryData} index={lbIndex} onClose={close} onPrev={prev} onNext={next}/>}
    </div>
  )
}
